import { render, staticRenderFns } from "./MomentGoodsRemarkCell.vue?vue&type=template&id=bc89085a&scoped=true&"
import script from "./MomentGoodsRemarkCell.vue?vue&type=script&lang=js&"
export * from "./MomentGoodsRemarkCell.vue?vue&type=script&lang=js&"
import style0 from "./MomentGoodsRemarkCell.vue?vue&type=style&index=0&id=bc89085a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc89085a",
  null
  
)

export default component.exports